/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ApplyToAllInfo from './ApplyToAllInfo/index'
import Dropdown from 'DesignSystem/Dropdown/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCaseCloser/Configuration/FeatureAccess/AddRuleset/Division/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let divisionsValueData = fromData.useDataValue({ viewPath,
context: 'divisions',
})
let rulesetDivisionIdValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'division_id',
})
let dtTypographyLineheightS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.lineHeight.s'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let onClick = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Dropdown
  viewPath={`${viewPath}/Dropdown`}
 data="divisions"
 from={divisionsValueData}
 data="ruleset.division_id"
 selected={rulesetDivisionIdValueData}
 onClick={onClick}
 label="division"
 marginTopInfo={dtSpaceXs}
 infoLineHeight={dtTypographyLineheightS}
 maxWidth={310}
 width={310}
 height={300}
 top={dtSpaceL}
/>
</div>
</div>
<ApplyToAllInfo
  viewPath={`${viewPath}/ApplyToAllInfo`}
/>
{children}
</React.Fragment>)
}